import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { MultiSelect } from 'primereact/multiselect'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px 1rem 1rem;

  .header-text {
    color: #363636;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    &.filter {
      display: flex;
      align-items: center;
      height: 30px;
      min-width: 410px;
    }
  }

  .map-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 auto;
  }
`
export const PageContainer = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 145px);
  align-items: center;
  padding: 0 1rem;
  column-gap: 24px;
  overflow: hidden;
`
export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  z-index: 1102;
`
export const TextButton = styled(Button)`
  height: 32px;
  border-radius: 10px;
  color: #45bfe5 !important;
  font-weight: 700;

  :focus {
    outline: 0 none !important;
    outline-offset: 0;
    box-shadow: none !important;
    background-color: none;
  }
`
export const StyledLink = styled(Link)`
  color: #45bfe5;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration: underline;
`

/* ########################### Left Side - Search & Filter Area ########################### */

export const FilterAreaContainer = styled.div`
  flex: 1 0 auto;
  height: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.25rem 0 0;
`
export const DropdownWrapper = styled.div`
  position: relative;
  .autocomplete-title {
    position: absolute;
    left: 1rem;
  }

  .autocomplete-icon {
    position: absolute;
    left: 0.5rem;
    top: 16px;
    z-index: 1;
    color: #a8a8a8;
  }

  .selectedVal,
  .p-dropdown .p-dropdown-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .selectedVal {
    font-size: 14px;
    margin-top: 0.5rem;
    margin-left: 0.1rem;
    font-weight: 600;
  }

  .p-dropdown .p-dropdown-label {
    padding-left: 1rem;
    padding-right: 0;
  }
`
export const StyledCustomDropdown = styled(Dropdown)`
  width: 100%;
  height: 50px;
  border-radius: 10px;
  align-items: center;

  .p-dropdown-panel {
    z-index: 1004 !important;
    position: absolute !important;
    left: 0px !important;
    top: 52px !important;
    min-width: 100% !important;
    min-height: 100% !important;
    background: #ffffff !important;
    transform-origin: center top !important;
  }

  .p-dropdown-items-wrapper {
    max-height: 220px !important;
    max-width: 530px !important;

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: none !important;
      background-color: #d3d3d3 !important;
      border-radius: 10px;
    }

    &::-webkit-scrollbar {
      height: 6px;
      width: 6px !important;
      background-color: #d3d3d3;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #7c7c7c;
      border-radius: 10px;
    }
  }
`
export const StyledDropdownItems = styled.div`
  padding: 0.5rem 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100% !important;
`

export const MultiSelectWrapper = styled.div`
  position: relative;
  .autocomplete-title {
    position: absolute;
    left: 1rem;
  }
  .autocomplete-icon {
    position: absolute;
    left: 8px;
    top: 16px;
    z-index: 1;
    color: #a8a8a8;
  }

  .p-multiselect .p-multiselect-label {
    font-size: 14px;
    font-weight: 600;
    margin-top: 0.6rem;
    margin-left: 0.05rem;
    padding-left: 1rem;
    padding-right: 0;
  }
`
export const StyledMultiSelect = styled(MultiSelect)`
  width: 100%;
  height: 50px;
  border-radius: 10px;
  align-items: center;
  //   justify-content: center;
  text-align: left;
`
export const SearchButton = styled(Button)`
  width: 100%;
  height: 50px;
  background: #45bfe5;
  border-radius: 10px;
  text-align: center;
  font-weight: 700;
`

/* Image - label - text */
export const BottomInfo = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .img-preview {
    display: none;
    height: calc(100% - 62px);
    @media screen and (min-width: 1200px) {
      display: block;
      width: 100%;
      // height: 100%;
      max-height: 140px;
    }
    @media screen and (min-width: 1300px) {
      display: block;
      width: 100%;
      // height: 100%;
      max-height: 220px;
    }

    @media screen and (min-width: 1600px) {
      display: block;
      margin: 1rem 0 0.5rem;
      height: calc(100% - 62px);
      max-height: 300px;
    }
  }

  .info-text {
    display: none;
    color: #646464;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0.65rem;

    @media screen and (min-width: 1200px) {
      display: flex;
      gap: 0.5rem;
    }
  }
`
export const ImagePreview = styled.div``

/* ########################### Map View - Map Container ########################### */
export const MapViewContainer = styled.div`
  flex: 1 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;

  .gm-style-iw-t {
    // bottom: 52px !important;
  }

  .gm-style .gm-style-iw-c {
    border-radius: 10px !important;
    padding: 1rem !important;
    min-width: 240px !important;
    max-width: 320px !important;

    button {
      top: -8px !important;
      right: -10px !important;
      width: 40px !important;
      height: 40px !important;
    }
  }

  .gm-style-iw-d {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    max-height: 220px !important;
  }

  .gm-style .gm-style-iw-tc {
    display: none;
  }
`
export const InfoWindowContent = styled.div`
  color: #363636;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 0.5rem;
  margin-top: 0.25rem;

  .title {
    color: #363636;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
  }

  .subtitle {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .desc {
    color: #21272a;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 19.2px */
  }
`

export const SearchBoxWrapper = styled.div`
  position: absolute;
  top: 30px;
  left: 24px;
`

export const MapSearchBoxInput = styled(InputText)`
  box-sizing: border-box;
  border: 1px solid transparent;
  width: 350px;
  height: 50px;
  padding: 0 36px 0 12px !important;
  border-radius: 10px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
  outline: none;
  text-overflow: ellipsis;
  font-size: 14px !important;
  font-weight: 500;
  line-height: normal;

  &.p-inputtext {
    &:hover {
      border-color: transparent !important;
    }

    &:focus {
      outline: 0 none !important;
      outline-offset: 0 !important;
      box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25) !important;
      border-color: transparent !important;
    }
  }
`

export const AutoCompleteWrapper = styled.div`
  .map-search-autocomplete i.p-autocomplete-loader {
    margin-right: 30px !important;
    display: block !important;
  }

  .map-search-autocomplete .p-inputtext {
    box-sizing: border-box;
    border: 1px solid transparent;
    width: 520px;
    height: 50px;
    padding: 0 36px 0 12px !important;
    border-radius: 10px;
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
    outline: none;
    text-overflow: ellipsis;
    font-size: 14px !important;
    font-weight: 500;
    line-height: normal;

    &:hover {
      border-color: transparent !important;
    }

    &:focus {
      outline: 0 none !important;
      outline-offset: 0 !important;
      box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25) !important;
      border-color: transparent !important;
    }
  }
`

/* ################################## List View Container  ################################## */

export const ListViewContainer = styled.div`
  position: relative;
  overflow-y: auto !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #a8a8a8;
  flex: 1 0 auto;
  // margin: 0 0 0.5rem;
  padding: 0 0 0.25rem;
`
export const ListItem = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  border-top: 1px solid #cecece;

  &:hover {
    background: #fafafa;
  }

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    border-bottom: 1px solid #cecece;
  }

  .p-radiobutton {
    margin-left: 1rem;
  }

  .location-img {
    width: 25px;
    height: 25px;
    margin: 0 0.5rem 0 1.5rem;
  }

  .list-content {
    flex: 1 0 auto;
    padding: 1rem;

    .title {
      color: #363636;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;

      width: 650px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    .subtitle {
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    .desc {
      color: #21272a;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; /* 19.2px */
    }
  }
`

/*  ################################## Floor Sidebar  ################################## */

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
export const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
  margin-bottom: 20px;

  .location-name {
    color: #45bfe5;
    font-size: 16px;
    font-weight: 700;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    .location-icon {
      margin-right: 4px;
      width: 24px;
      height: 24px;
    }
  }

  .firm-name {
    color: #363636;
    font-size: 14px;
    font-weight: 700;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .location-address {
    color: #21272a;
    font-size: 14px;
    font-weight: 400;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`
export const Header = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #363636;
`
export const ContentArea = styled.div`
  flex-grow: 1;
`
export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;

  .reservation-subtitle {
    font-size: 1rem !important;
    font-weight: 700;
    line-height: 19px;
  }
`
export const InfoListItem = styled.div<{ isSelected: boolean }>`
  background-color: ${({ isSelected }) => `${isSelected ? 'rgba(69, 191, 229, 0.2)' : '#FFF'}`};
  display: flex;
  align-items: center;
  padding: 0.5rem;
  column-gap: 0.75rem;
  overflow: hidden;
  cursor: pointer;
  border-bottom: 1px solid #ebebeb;
  border-radius: 4px;

  img {
    width: 24px;
    height: 24px;
    margin-right: 0.125rem;
  }

  .item-content {
    // flex: 1 0 auto;
    font-size: 14px;
    color: #21272a;
    display: flex;
    flex-direction: column;
    width: 30%;

    .sub-header {
      font-weight: 700;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .sub-text {
      font-weight: 400;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`
export const SidebarActionArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding-bottom: 0.5rem;
`
export const SidebarButton = styled(Button)`
  width: 100%;
  height: 50px;
  background: #45bfe5;
  border-radius: 10px;
  justify-content: center;
`
